import router from "../routes.config.js";

const directives = {
    mylink : function(el,params){
        //加事件
        $(el).on("click",function(){

            //push表示压如history栈，此时网页将跳转
            router.push(params.value);
        });

    },
    title:{
	    inserted: function (el, binding) {
	    	if(binding.value.title){
	    		document.title = binding.value.title
	    	}else{
	    		document.title = binding.value
	    	}
	    }
    },
    refresh(el){
        $(el).on("click",function(){
            // document.frames('pdfContainer').location.reload()
            pdfContainer.window.location.reload()
        })
    }
}

export default directives;


// WEBPACK FOOTER //
// ./src/directives/pushlink.js